// extracted by mini-css-extract-plugin
export default {"TagGroup":"TagGroup_owSac","SiteTagPlus":"SiteTagPlus_BSkFC","EditTag":"EditTag_IiGt2","TagInput":"TagInput_YH0Dc","TagIcon":"TagIcon_PFdTO"};